import { Parallax } from "react-scroll-parallax"
import "./kv.css"
import { BackgroundedImage, ImageContent, RichTextContent } from "../../../src/lib/strapi/strapi-react";

class Kv extends React.Component {
  constructor(props) {
    super(props)
  }
  createKvText() {
    return this.props.text.split("\n").filter(t => t).map((text, index) => {
      var delay = index * 1000

      return (
        <div
          key={index}
          data-aos="fade-in"
          data-aos-duration="600"
          data-aos-delay={delay}
        ><RichTextContent content={text} /></div>
      )
    })
  }
  kvClasses() {
    let classes = "kv com-kv"
    if (this.props.type) {
      classes = "kv com-kv sty-inner"
    }
    return classes
  }
  createBackground() {
    if (this.props.page) {
      return (
        <BackgroundedImage content={this.props.backgroundImage} divClassName="bg" />
      )
    } else {
      return (
        <Parallax y={[-100, 20]} className="parallax-container">
          <div className="desktop-only"><ImageContent content={this.props.backgroundImage} /></div>
          <div className="mobile-only"><ImageContent content={this.props.backgroundImageMobile} /></div>
        </Parallax>
      )
    }
  }

  render() {
    return (
      <section className={this.kvClasses()}>
        {this.createBackground()}
        <div className="container">
          <div className="inner-container">
            <div className="wrapper">
              <h1 className="desc">{this.createKvText()}</h1>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Kv
